<div class="bodycontent">
    <div class="subheader with-padding flgrow">
        <div class="row">

            <!--  Dealer Dropdown -->
            <div class="col-lg-2 col-md-6 col-sm-8" *ngIf="dealers && dealers?.length > 0">
                <div class="relative flmid">
                    <div class="flgrow">
                        <ng-select class="w-100" placeholder="{{ 'lblSelectDealer' | translate }}"
                            [(ngModel)]="dealerId" name="dealerId" (change)="onDealerChanged($event)">
                            <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
                                {{ dealer.dealerName }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <p *ngIf="isRequired" class="help-block text-danger" translate>
                    lblRequiredDealer
                </p>
            </div>

            <!--  Status Dropdown -->
            <div class="col-lg-2 col-md-6 col-sm-8">
                <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                    (change)="StatusChange($event)">
                    <ng-option *ngFor="let status of StatusList" [value]="status.id">
                        {{status.value}}
                    </ng-option>
                </ng-select>
            </div>

            <!-- Date Range Picker -->
            <div class="col-lg-2 col-md-6 col-sm-8">
                <div class="relative flmid">
                    <div class="flgrow">
                        <div class="date">
                            <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                            [(ngModel)]="selectedDate" (ngModelChange)="onDateRangeChanged($event)"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
                <div class="d-flex">
                    <button type="button" (click)="onSearchReport()" class="btn btn-primary btn">
                        <em class="fa fa-search"></em>
                    </button>
                    <button type="button" (click)="clearSearch()" class="ml-2 btn btn-primary btn">
                        <em class="far fa-times-circle font16 align-top"></em>
                    </button>
                </div>
            </div>

            <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto">
                <!-- Excel -->
                <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}"
                    placement="bottom" aria-label="Center Align" style="margin-right: 10px; ">
                    <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
                </button>
                <!-- PDF -->
                <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" style="margin-top: -0.4rem;"
                    ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
                    <em class="far fa-file fa-2x"></em>
                    <span class="bdg">PDF</span>
                </button>
            </div>

        </div>
    </div>

    <!-- Body -->
    <div class="container prel">
        <div class="row">
            <div class="c12">
                <div class="card mb-3">
                    <!-- Body Header -->
                    <div class="card-header d-flex justify-content-between" translate>
                        lblAdditionalWorkReport
                        <div class="font16 fontbold">
                            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                            {{ totalCount }}
                            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                        </div>
                    </div>
                    <!-- Body Content -->
                    <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                        [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
                        <table class="tablest1">
                            <thead>
                                <tr>
                                    <th style="width: 55px" scope="col">#</th>
                                    <th scope="col" style="width: 10%" sortable="WorkOrderNumber"
                                        (sort)="onSort($event)" translate>lblWoNo</th>
                                    <th scope="col" style="width: 10%" translate>
                                        lblRegNumber
                                    </th>
                                    <th scope="col" style="width: 10%" sortable="WorkOrderStatus"
                                        (sort)="onSort($event)" translate> lblWoStatus
                                    </th>
                                    <th style="width: 10%" scope="col" translate>lblDealersName</th>
                                    <th style="width: 10%" scope="col" sortable="CustomerName" (sort)="onSort($event)"
                                        translate>lblCustomer</th>
                                    <th style="width: 10%" scope="col" sortable="BookedDate" (sort)="onSort($event)"
                                        translate>lblBookedDate</th>
                                    <th style="width: 10%" scope="col" sortable="BillToCustomer" (sort)="onSort($event)"
                                        translate>lblBillToCustomer</th>
                                    <th style="width: 20%" scope="col" sortable="DemandShortDescription"
                                        (sort)="onSort($event)" translate>lblDemands</th>
                                    <th style="width: 10%" scope="col" sortable="TotalPrice" (sort)="onSort($event)"
                                        translate>
                                        lblTotalPrice <span translate>lblInclVAT</span>
                                    </th>
                                    <th style="width: 10%" scope="col" sortable="Status" (sort)="onSort($event)"
                                        translate class="text-center">lblStatus</th>
                                </tr>
                            </thead>

                            <tbody>
                                <ng-container *ngIf="additionalWorkList?.length > 0; else load_NotFound_Template">
                                    <tr *ngFor="let item of additionalWorkList; let i = index">
                                        <td>{{ i + 1 }}</td>
                                        <td>
                                            <ngb-highlight [result]="item.workOrderNumber"> </ngb-highlight>
                                        </td>
                                        <td>
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{item.licensePlate}}
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            <div style="margin-right: 40px">
                                                <ngb-highlight [result]="item.workOrderStatus"> </ngb-highlight>
                                            </div>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="item.dealerName"> </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="item.customerName"> </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="item.bookedDate | date: 'shortDate'">
                                            </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="item.billToCustomer"> </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="item.demandShortDescription"> </ngb-highlight>
                                        </td>
                                        <td class="text-right">
                                            <div style="margin-right: 40px">
                                                <ngb-highlight [result]="item.totalPrice | number:'1.2-2' ">
                                                </ngb-highlight>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <ngb-highlight [result]="item.status"> </ngb-highlight>
                                        </td>
                                    </tr>
                                </ng-container>

                                <ng-template #load_NotFound_Template>
                                    <tr>
                                        <td colspan="10" class="no-record" translate>
                                            lblNoRecordsFound
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>